export class TextareaInputResizer {

    public static checkHeight($event: InputEvent): void {

        const textarea = $event.target as HTMLTextAreaElement;

        if (!textarea) {
            return;
        }

        if (textarea.scrollHeight < textarea.offsetHeight) {
            return;
        }

        textarea.style.height = 'auto';
        textarea.style.height = `${textarea.scrollHeight}px`;
    }
}